import {
  ACTION_SET,
  ACTION_INC,
  ACTION_PUSH,
  ACTION_PULL,
  ACTION_DEL,
  ACTION_PULL_WHERE,
} from './constants';

export const set = (key, value) => ({
  type: ACTION_SET,
  payload: value,
  meta: {
    key,
  },
});

export const inc = (key, value) => ({
  type: ACTION_INC,
  payload: value,
  meta: {
    key,
  },
});

export const push = (key, value) => ({
  type: ACTION_PUSH,
  payload: value,
  meta: {
    key,
  },
});

export const pull = (key, value, options) => ({
  type: ACTION_PULL,
  payload: value,
  meta: {
    key,
    options,
  },
});

export const pullWhere = (key, value, options) => ({
  type: ACTION_PULL_WHERE,
  payload: value,
  meta: {
    key,
    options,
  },
});

export const del = (key, options) => ({
  type: ACTION_DEL,
  meta: {
    key,
    options,
  },
});

export const reset = () => ({
  type: ACTION_DEL,
  meta: {
    key: '',
  },
});

export const scopeAction = (section, reducer) => (action) => {
  const match = /@SCOPE\[(.*)\](.*)/.exec(action.type);
  let type;
  if (match) {
    type = `@SCOPE[${section}.${match[1]}]${match[2]}`;
  } else {
    type = `@SCOPE[${section}] ${action.type}`;
  }
  return {
    type,
    payload: action,
    meta: {
      section,
      ...(reducer && {
        reducer,
      }),
    },
  };
};

export const scopeActionCreator = (section, reducer) => {
  const wrapAction = scopeAction(section, reducer);
  return (actionCreator) =>
    (...args) =>
      wrapAction(actionCreator(...args));
};
